import { useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useMediaQuery, Tabs, Tab, Box } from '@mui/material';

import { CircleLoading } from 'shared';
import { useThemeToggle } from '../../hooks/useThemeToggle';
import { useCompanyService } from '../../store/services/company.service';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

const Subscriptions = () => {
    const navigate = useNavigate();
    const { themeMode } = useThemeToggle();
    const isDarkMode = themeMode === 'dark' ? true : false;
    const publishableKey = process.env.REACT_APP_STRIPE_INTENT;
    const publishableKeyInvoicePlan = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_INVOICE;
    const isScreenLowerThan1024 = useMediaQuery('(max-width: 1025px)');
    const pricingTableId = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID;
    const pricingTableIdInvoice = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID_INVOICE;
    const { createStripeSession, getStripeTableSession } = useCompanyService();

    const [stripeSession, setStripeSession] = useState(null);
    const companyData = useSelector((state) => state.company.data);
    const [referralId, setReferralId] = useState(null);

    useEffect(() => {
        if (companyData && companyData?.stripeStatus === 'active') {
            navigate('/purchases');
        }
    }, [companyData]);

    useEffect(() => {
        if (window.Rewardful && window.Rewardful.referral) {
            setReferralId(window.Rewardful.referral);
        }

        window.rewardful('ready', () => {
            if (window.Rewardful && window.Rewardful.referral) {
                setReferralId(window.Rewardful.referral);
            }
        });
    }, []);

    const handleCreateStripeSession = useCallback(async () => {
        const response = await createStripeSession(companyData?.id);

        if (response.url) {
            window.location.href = response.url;
        }
    }, [createStripeSession]);

    const handleStripeSession = async () => {
        try {
            const response = await getStripeTableSession(companyData?.id);
            setStripeSession(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/pricing-table.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        if (companyData) {
            handleStripeSession();
        }
    }, [referralId, companyData]);

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return stripeSession ? (
        <div style={{ marginTop: '-50px' }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                }}
            >
                <button
                    onClick={handleCreateStripeSession}
                    style={{
                        color: 'grey',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        margin: '0 0 15px 30px',
                    }}
                >
                    Manage Billing
                </button>
            </div>

            <Box sx={{ width: '100%', mb: 2, mt: 1 }}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    centered
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#0061db',
                        },
                        '& .MuiTab-root.Mui-selected': {
                            color: '#0061db',
                            fontWeight: 'bold',
                        },
                        '& .MuiTab-root': {
                            color: isDarkMode ? '#9ca3af' : '#6b7280',
                            textTransform: 'none',
                            fontSize: '1rem',
                        },
                    }}
                >
                    <Tab label="Purchase Reconciler" />
                    <Tab label="Invoice Reconciler" />
                </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                        flexDirection: 'column',
                        margin: '0 25px',
                    }}
                >
                    <p
                        style={{
                            fontWeight: '700px',
                            fontSize: isScreenLowerThan1024 ? '20px' : '24px',
                            color: isDarkMode ? '#F9FAFB' : '#121826',
                            margin: '0px',
                        }}
                    >
                        Start with a 14-Day Free Trial. Full access. No risk. Cancel Anytime.
                        {/* {companyData?.stripeStatus === 'trialing'
                        ? 'Upgrade now to enjoy uninterrupted access! Pay only after your trial ends.'
                        : 'Your trial has ended. Upgrade today to continue enjoying key benefits'} */}
                    </p>

                    <p style={{ margin: '0px' }}>
                        Your card won't be charged until trial period is over.
                    </p>
                </div>

                <stripe-pricing-table
                    pricing-table-id={pricingTableId}
                    publishable-key={publishableKey}
                    customer-session-client-secret={stripeSession?.client_secret}
                    client-reference-id={referralId}
                >
                    {tabValue === 0 && (
                        <script
                            type="application/json"
                            data-stripe-subscription-data='{"trial_period_days":14}'
                        ></script>
                    )}
                </stripe-pricing-table>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '10px 25px 20px 25px',
                    }}
                >
                    <div
                        style={{
                            maxWidth: '800px',
                            textAlign: 'left',
                            color: isDarkMode ? '#F9FAFB' : '#121826',
                        }}
                    >
                        <p
                            style={{
                                fontSize: '14px',
                            }}
                        >
                            *Currently Skybox supported
                        </p>

                        <p
                            style={{
                                margin: '0 0 7px 0',
                                fontSize: '14px',
                            }}
                        >
                            Additional Usage Charges (if monthly limits are exceeded):
                        </p>

                        <ul
                            style={{
                                listStyle: 'none',
                                padding: '0',
                                margin: '0',
                            }}
                        >
                            <li
                                style={{
                                    marginBottom: '2px',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span style={{ marginRight: '8px' }}>•</span>
                                <span
                                    style={{
                                        fontSize: '14px',
                                    }}
                                >
                                    Emails: $0.005 per email
                                </span>
                            </li>

                            <li
                                style={{
                                    marginBottom: '8px',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span style={{ marginRight: '8px' }}>•</span>
                                <span
                                    style={{
                                        fontSize: '14px',
                                    }}
                                >
                                    Purchase inventory upload: $0.005 per entry
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                        flexDirection: 'column',
                        margin: '0 25px',
                    }}
                >
                    <p
                        style={{
                            fontWeight: '700px',
                            fontSize: isScreenLowerThan1024 ? '20px' : '24px',
                            color: isDarkMode ? '#F9FAFB' : '#121826',
                            margin: '0px',
                        }}
                    >
                        Invoice Reconciler Plans
                    </p>
                    <p style={{ margin: '0 0 20px 0' }}>
                        Choose the plan that works best for your business
                    </p>
                </div>
                <stripe-pricing-table
                    pricing-table-id={pricingTableIdInvoice}
                    publishable-key={publishableKeyInvoicePlan}
                    customer-session-client-secret={stripeSession?.client_secret}
                ></stripe-pricing-table>
            </TabPanel>
        </div>
    ) : (
        <CircleLoading />
    );
};

export default Subscriptions;
